export default __webpack_public_path__ + "static/media/healthwise.b4ed4370.png";